@if (isUserImage()) {
  <mp-avatar [image]="image()" [name]="name()" [size]="size()" (imageLoadError)="handleImageLoadError()" />
} @else {
  <mp-image
    class="image"
    [imagePath]="image()"
    [alternateText]="alternateText()"
    (imageLoadError)="handleImageLoadError()"
  />
}

<div class="image-button">
  <button type="button" class="image-button__button" mat-button color="accent" [matMenuTriggerFor]="menu">
    <mat-icon>add_photo_alternate</mat-icon>
    BILD ÄNDERN
  </button>

  <mat-icon class="image-button__info material-icons-outlined" [title]="tooltip">info</mat-icon>
</div>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="fileInput.click()">Bild auswählen</button>

  @if (image()) {
    <button mat-menu-item (click)="clearImage()">Bild entfernen</button>
  }
</mat-menu>

<input #fileInput hidden type="file" [accept]="acceptedFormats" (change)="onFileChange($event)" />
